// extracted by mini-css-extract-plugin
export default {"container":"staff-toolbar_container__2xr_b","inner":"staff-toolbar_inner__2b48Y","button":"staff-toolbar_button__1VKvX"};